import * as type from './dashboardActionType';

// myStats actions
export const setStatsAction = (statsData) => ({
  type: type.SET_STATS,
  statsData,
});

export const loadStatsAction = () => ({
  type: type.LOAD_STATS,
});

export const loadPointsThisWeek = () => ({
  type: type.LOAD_POINTS_THIS_WEEK,
});

export const loadPointsThisWeekWaiting = (value) => ({
  type: type.SET_POINTS_THIS_WEEK_WAITING,
  value,
});

export const setPointsThisWeek = (data) => ({
  type: type.SET_POINTS_THIS_WEEK,
  data,
});

// activity actions

export const setActivityAction = (activityData) => ({
  type: type.SET_ACTIVITY,
  activityData,
});
export const loadActivityAction = (timePeriod) => ({
  type: type.LOAD_ACTIVITY,
  timePeriod,
});

// leaderboard actions

export const setFriendLeaderboardAction = (friendLeaderboard) => ({
  type: type.SET_FRIEND_LEADERBOARD,
  friendLeaderboard,
});

export const loadFriendLeaderboardAction = (timePeriod) => ({
  type: type.LOAD_FRIEND_LEADERBOARD,
  timePeriod,
});

export const loadFriendLeaderboardWaiting = (value) => ({
  type: type.LOAD_FRIEND_LEADERBOARD_WAITING,
  value,
});

export const setEveryoneLeaderboardAction = (everyoneLeaderboard) => ({
  type: type.SET_EVERYONE_LEADERBOARD,
  everyoneLeaderboard,
});

export const loadEveryoneLeaderboardAction = (timePeriod) => ({
  type: type.LOAD_EVERYONE_LEADERBOARD,
  timePeriod,
});

export const loadEveryoneLeaderboardWaiting = (value) => ({
  type: type.LOAD_EVERYONE_LEADERBOARD_WAITING,
  value,
});

// for scoring history
export const setScoringHistoryAction = (scoringHistoryData) => ({
  type: type.SET_SCORING_HISTORY,
  scoringHistoryData,
});
export const getScoringHistoryAction = (timePeriod) => ({
  type: type.GET_SCORING_HISTORY,
  timePeriod,
});

export const setLoadingScoringHistory = (value) => ({
  type: type.SET_LOADING_SCORING_HISTORY,
  value,
});

// Badges actions
export const getBadgesAction = (skip, limit) => ({
  type: type.GET_BADGES,
  skip,
  limit,
});

export const setBadgesAction = (badges) => ({
  type: type.SET_BADGES,
  badges,
});

export const setIsLoadingBadgesAction = (isLoadingBadges) => ({
  type: type.SET_IS_LOADING_BADGES,
  isLoadingBadges,
});

// Daily quiz History actions

export const getDailyQuizHistoryAction = (skip, limit, reset = false) => ({
  type: type.GET_DAILY_QUIZ_HISTORY,
  skip,
  limit,
  reset,
});

export const getQualDailyQuizHistoryAction = (skip, limit, reset = false) => ({
  type: type.GET_QUAL_DAILY_QUIZ_HISTORY,
  skip,
  limit,
  reset,
});

export const getOneDailyQuizHistoryAction = (id, isLastQuiz = false) => ({
  type: type.GET_ONE_DAILY_QUIZ_HISTORY,
  id,
  isLastQuiz,
});

export const getOneQualDailyQuizHistoryAction = (id, isLastQuiz = false) => ({
  type: type.GET_ONE_QUAL_DAILY_QUIZ_HISTORY,
  id,
  isLastQuiz,
});

export const resetOneQualDailyQuizHistoryAction = () => ({
  type: type.RESET_ONE_QUAL_DAILY_QUIZ_HISTORY,
});

export const setDailyQuizHistoryAction = (dailyQuizHistory, reset = false) => ({
  type: type.SET_DAILY_QUIZ_HISTORY,
  dailyQuizHistory,
  reset,
});

export const setQualDailyQuizHistoryAction = (
  dailyQuizHistory,
  reset = false,
) => ({
  type: type.SET_QUAL_DAILY_QUIZ_HISTORY,
  dailyQuizHistory,
  reset,
});

export const resetDailyQuizHistory = () => ({
  type: type.RESET_DAILY_QUIZ_HISTORY,
});

export const setIsLoadingDailyQuizHistoryAction = (isLoadingQuizHistory) => ({
  type: type.SET_IS_LOADING_DAILY_QUIZ_HISTORY,
  isLoadingQuizHistory,
});

export const setIsQualDailyQuizHistoryLoading = (value) => ({
  type: type.SET_IS_QUAL_DAILY_QUIZ_HISTORY_LOADING,
  value,
});

export const setLoadingReviewDailyQuiz = (value) => ({
  type: type.SET_LOADING_REVIEW_DAILY_QUIZ,
  value,
});
export const setLoadingReviewQualDailyQuiz = (value) => ({
  type: type.SET_LOADING_REVIEW_QUAL_DAILY_QUIZ,
  value,
});

// Practice Exam History actions
export const setCustomPracticeExamHistory = (value) => ({
  type: type.SET_CUSTOM_PRACTICE_EXAM_HISTORY,
  value,
});

export const setPracticeExamAction = (practiceExamHistory) => ({
  type: type.SET_PRACTICE_EXAM_HISTORY,
  practiceExamHistory,
});

export const setIsLoadingPracticeExamHistoryAction = (
  isLoadingPracticeExamHistory,
) => ({
  type: type.SET_IS_LOADING_PRACTICE_EXAM_HISTORY,
  isLoadingPracticeExamHistory,
});

export const oneDailyQuizHistoryAction = (oneDailyQuizHistory) => ({
  type: type.ONE_DAILY_QUIZ_HISTORY,
  oneDailyQuizHistory,
});

export const setOneQualDailyQuizHistoryAction = (oneQualDailyQuizHistory) => ({
  type: type.SET_ONE_QUAL_DAILY_QUIZ_HISTORY,
  oneQualDailyQuizHistory,
});

export const resetPracticeExamHistory = () => ({
  type: type.RESET_PRACTICE_EXAM_HISTORY,
});

// Recomended Topics actions

export const getRecomendedTopicsAction = () => ({
  type: type.GET_RECOMENDED_TOPICS,
});

export const setRecomendedTopicsAction = (recomendedTopics) => ({
  type: type.SET_RECOMENDED_TOPICS,
  recomendedTopics,
});

export const setIsLoadingRecomendedTopicsAction = (isLoadingRecomended) => ({
  type: type.SET_IS_LOADING_RECOMENDED_TOPICS,
  isLoadingRecomended,
});

// Featured Blog actions

export const getFeaturedBlogAction = () => ({
  type: type.GET_FEATURED_BLOG,
});

export const setFeaturedBlogAction = (featuredBlog) => ({
  type: type.SET_FEATURED_BLOG,
  featuredBlog,
});

export const setIsLoadingFeaturedBlogAction = (isLoadingFeaturedBlog) => ({
  type: type.SET_IS_LOADING_FEATURED_BLOG,
  isLoadingFeaturedBlog,
});

// Featured Podcast actions

export const getFeaturedPodcastAction = () => ({
  type: type.GET_FEATURED_PODCAST,
});

export const setFeaturedPodcastAction = (featuredPodcast) => ({
  type: type.SET_FEATURED_PODCAST,
  featuredPodcast,
});

export const setIsLoadingFeaturedPodcastAction = (
  isLoadingFeaturedPodcast,
) => ({
  type: type.SET_IS_LOADING_FEATURED_PODCAST,
  isLoadingFeaturedPodcast,
});

// Featured Forum actions

export const getFeaturedForumAction = () => ({
  type: type.GET_FEATURED_FORUM,
});

export const setFeaturedForumAction = (featuredForum) => ({
  type: type.SET_FEATURED_FORUM,
  featuredForum,
});

export const setIsLoadingFeaturedForumAction = (isLoadingFeaturedForum) => ({
  type: type.SET_IS_LOADING_FEATURED_FORUM,
  isLoadingFeaturedForum,
});

// Invite a frined actions
export const getInviteAFriendAction = () => ({
  type: type.GET_FEATURED_FORUM,
});

export const setInviteAFRiendAction = (response) => ({
  type: type.SET_INVITE_A_FRIEND,
  response,
});

export const setIsLoadingInviteAFriendAction = (isLoadingInviteAFriend) => ({
  type: type.SET_IS_LOADING_INVITE_A_FRIEND,
  isLoadingInviteAFriend,
});

export const openPdfViewer = (value) => ({
  type: type.OPEN_PDF_VIEWER,
  value,
});

// for dashboard header & jump back-in

export const loadDashboardHeaderInfo = () => ({
  type: type.LOAD_DASHBOARD_HEADER_INFO,
});

export const setDashboardHeaderInfoWaiting = (value) => ({
  type: type.SET_DASHBOARD_HEADER_INFO_WAITING,
  value,
});

export const setDashboardHeaderInfo = (data) => ({
  type: type.SET_DASHBOARD_HEADER_INFO,
  data,
});

export const setUserCycle = (cycleId) => ({
  type: type.SET_USER_CYCLE,
  cycleId,
});

export const setUpdateCycleMessage = (message) => ({
  type: type.SET_UPDATE_CYCLE_MESSAGE,
  message,
});
